/* Kurzes Konfetti, wenn der Warenkorb die Gratisversand-Schwelle erreicht (16.10.2026).
   Feiert nur den Übergang von «noch nicht» zu «geschafft», nicht jeden Seitenaufruf mit vollem Balken.
   Zustand in sessionStorage; bei reduzierter Bewegung nur ein kurzes Aufleuchten des Balkens. */
(() => {
  if (window.__gftKonfetti) return;
  window.__gftKonfetti = true;
  const SCHLUESSEL = 'gftVersandFrei';
  const FARBEN = ['#00636A', '#00636A', '#e04d4f', '#f2913a', '#f6c453', '#1f8a8a', '#00636A', '#C9DAD9'];
  const ruhig = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  let letzter = null;
  try { letzter = sessionStorage.getItem(SCHLUESSEL); } catch (_) {}
  const merken = w => { letzter = w; try { sessionStorage.setItem(SCHLUESSEL, w); } catch (_) {} };

  function feiern(el) {
    const meter = el.querySelector('.gft-cart-meter');
    if (meter && meter.animate) meter.animate([{ boxShadow: '0 0 0 0 rgba(242,145,58,.0)' }, { boxShadow: '0 0 0 6px rgba(242,145,58,.35)' }, { boxShadow: '0 0 0 0 rgba(242,145,58,0)' }], { duration: 900, easing: 'ease-out' });
    if (ruhig() || !document.body.animate) return;
    const r = (meter || el).getBoundingClientRect();
    if (!r.width) return;
    const ebene = document.createElement('div');
    ebene.className = 'gft-konfetti';
    ebene.setAttribute('aria-hidden', 'true');
    document.body.appendChild(ebene);
    const n = window.innerWidth < 600 ? 46 : 64;
    let fertig = 0;
    for (let i = 0; i < n; i++) {
      const s = document.createElement('i');
      const gross = 6 + Math.random() * 6;
      const rund = Math.random() < .35;
      s.style.width = `${gross}px`;
      s.style.height = `${rund ? gross : gross * .45}px`;
      s.style.borderRadius = rund ? '50%' : '2px';
      s.style.background = FARBEN[i % FARBEN.length];
      const x0 = r.left + Math.random() * r.width, y0 = r.top + r.height / 2;
      s.style.left = `${x0}px`; s.style.top = `${y0}px`;
      ebene.appendChild(s);
      const dx = (Math.random() - .5) * 260, hoch = 90 + Math.random() * 150, fall = 140 + Math.random() * 220;
      const dreh = (Math.random() - .5) * 900, dauer = 1300 + Math.random() * 700;
      s.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: `translate(${dx * .6}px,${-hoch}px) rotate(${dreh * .5}deg)`, opacity: 1, offset: .35 },
        { transform: `translate(${dx}px,${fall - hoch}px) rotate(${dreh}deg)`, opacity: 0 }
      ], { duration: dauer, easing: 'cubic-bezier(.2,.7,.4,1)', delay: Math.random() * 120, fill: 'forwards' })
        .finished.then(() => { if (++fertig >= n) ebene.remove(); }).catch(() => {});
    }
    setTimeout(() => ebene.remove(), 3000);
  }

  function pruefen() {
    const sichtbar = x => { const r = x.getBoundingClientRect(); const ok = x.checkVisibility ? x.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true }) : x.offsetParent !== null; return ok && r.width > 0 && r.right > 0 && r.left < window.innerWidth; };
    const alle = [...document.querySelectorAll('[data-gft-frei]')];
    const el = alle.find(sichtbar) || alle[0];
    if (!el) { if (letzter === null) merken('nein'); return; }
    const jetzt = el.dataset.gftFrei === 'ja' ? 'ja' : 'nein';
    if (letzter === 'nein' && jetzt === 'ja') {
      merken('ja');
      // Warten, bis ein Seitenfenster sichtbar ist
      const versuch = (n) => { const z = [...document.querySelectorAll('[data-gft-frei="ja"]')].find(sichtbar); if (z) feiern(z); else if (n > 0) setTimeout(() => versuch(n - 1), 450); };
      setTimeout(() => versuch(2), 350);
    } else if (letzter !== jetzt) merken(jetzt);
  }

  let geplant = false;
  const planen = () => { if (geplant) return; geplant = true; requestAnimationFrame(() => { geplant = false; pruefen(); }); };
  const start = () => {
    pruefen();
    new MutationObserver(m => { if (m.some(x => x.addedNodes.length)) planen(); }).observe(document.body, { childList: true, subtree: true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
